
import Vue from 'vue';
import _take from 'lodash/take';
import { mapState, mapActions, mapGetters } from 'vuex';
import ConfirmDialog from '@/components/base/ConfirmDialog.vue';
import GlassButton from '@/components/base/GlassButton.vue';
import { RUNNITS_OWNER_SELECTION } from '@/views/Runnits/constants';
import { TeamUserMixin } from '@/mixins';
import { PRIVATE_STORAGE_CAP_BYTES, SHARED_STORAGE_CAP_BYTES } from '@/components/StorageCapCard/utils';
import { ROUTER } from '@/router/constants';
import { RD_ADMIN_PERMISSION_LABEL } from '@run-diffusion/shared';

export default Vue.extend({
	name: 'StorageCapCard',
	mixins: [
		TeamUserMixin,
	],
	props: {
		styles: { type: [String, Object], default: null },
		selectionEnabled: { type: Boolean, default: false },
	},
	data () {
		return {
			ROUTER,
			RD_ADMIN_PERMISSION_LABEL,
			SHARED_STORAGE_CAP_BYTES,
			PRIVATE_STORAGE_CAP_BYTES,
			isDisclaimerDialogOpen: false,
		};
	},
	computed: {
		...mapState([
			'user',
			'team',
			'workspaces',
			'runnitState',
		]),
		...mapGetters([
			'userClubOfferBenefits',
			'displayLabels',
		]),
		firstFewWorkspaces () {
			return _take(this.workspaces, 3);
		},
		teamSelected () {
			return this.runnitState.runnitsOwnerSelection === RUNNITS_OWNER_SELECTION.TEAM;
		},
		isOverSharedStorage () {
			return this._get(this.user, 'sharedStorageBytes') > SHARED_STORAGE_CAP_BYTES;
		},
	},
	methods: {
		...mapActions([
			'setUpsellDialog',
		]),
		openDisclaimerDialog () {
			this.isDisclaimerDialogOpen = true;
		},
	},
	components: {
		ConfirmDialog,
		GlassButton,
	},
});
